<template>
  <div class="life-cycle flex-box">
    <div class="life-cycle-title">{{ title }}</div>
    <div class="life-cycle-description">{{ description }}</div>
    <div class="container">
      <div class="content-box">
        <div class="list-item" v-for="(item, k) in listData" :key="k">
          <div class="item-num">{{ item.num }}</div>
          <div class="item-description">{{ item.description }}</div>
          <div class="item-hover-mark"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    listData: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
    }
  },
  watch: {
  },
  mounted() {
  },
  destroyed() {
  },
  methods: {
   
  }
}
</script>

<style lang="scss" scoped>
$img: "../../assets/images";

.life-cycle {
  flex-direction: column;
  align-items: center;
  background: linear-gradient( 180deg, #66ACFF 0%, #3674FE 100%);

  .life-cycle-title {
    font-size: 4rem;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    line-height: 4rem;
    padding: 8rem 0 2.4rem;
  }

  .life-cycle-description {
    font-size: 1.8rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 1.8rem;
    padding-bottom: 5.2rem;
  }

  .container {
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .content-box {
    position: relative;
    width: calc(192rem - 50rem);
    margin: 0 auto 4rem;
    overflow: hidden;

    .list-item {
      float: left;
      width: 68rem;
      height: 18rem;
      background: #FFFFFF;
      box-shadow: 0rem 0.5rem 4rem 0rem rgba(196,211,228,0.3);
      padding: 6.7rem 4rem 0;
      margin: 0rem 5rem 4rem 0;
      cursor: pointer;
      position: relative;
      &:nth-child(even) {
        margin-right: 0;
      }
      .item-num {
        position: absolute;
        left: 4rem;
        top: 2.7rem;
        opacity: .1;
        height: 7.2rem;
        font-family: DINAlternate, DINAlternate;
        font-weight: bold;
        font-size: 7.2rem;
        color: #3674FE;
        line-height: 7.2rem;
        text-align: left;
        font-style: normal;
      }
      .item-description {
        line-height: 3.2rem;
        font-size: 2rem;
        color: #333333;
        font-family: PingFangSC, PingFang SC;
      }
      .item-hover-mark {
        position: absolute;
        right: 1rem;
        bottom: 1rem;
      }
      &:hover {
        .item-hover-mark {
          width: 0;
          height: 0;
          border-width: 2.4rem; /* 设置边长 */
          border-style: solid;
          border-color: transparent #3E7EFE #3E7EFE transparent; /* 上、右、下为透明色，左为指定的颜色（这里为黑色）*/
        }
      }
    }

  }
}

@import "@/styles/mixins.scss";

@include mobile {
  .life-cycle {
    .life-cycle-title {
      font-size: 2.4rem;
      line-height: 3.2rem;
      padding: 4.8rem 1.6rem 1.6rem;
      text-align: center;
    }
    .life-cycle-description {
      font-size: 1.4rem;
      line-height: 2.2rem;
      padding: 0 1.6rem 2.4rem;
      text-align: center;
    }
    .content-box {
      width: 100%;
      padding: 0 1.6rem;
      overflow: visible;
      .list-item {
        float: none;
        width: 100%;
        height: auto;
        margin: 0 0 1.6rem;
        padding: 4.8rem 1.6rem 2.4rem;
        .item-description {
          height: auto;
          white-space: normal;
          word-break: break-word;
          overflow-wrap: break-word;
        }
      }
    }
  }
}
</style>
